export const assetsPath = "assets/";
var imgsPath = assetsPath + "img/";
export const audioPath = assetsPath + "audio/";

export var to_load_json_atlas = {
    'symbols_atlas': [ imgsPath + "symbols/symbols_atlas_{q}.png", imgsPath + "symbols/symbols_atlas_{q}.json"],
    'symbols_blur_atlas': [ imgsPath + "symbols/symbols_blur_atlas_{q}.png", imgsPath + "symbols/symbols_blur_atlas_{q}.json"]
};

export const to_load = {
    'coin_sprite'				: 'framework/assets/img/coin/coins_{q}.png',
    'win_font_bg'				: imgsPath + 'fonts/win_font_bg_{q}.png',

    'background'					: imgsPath + 'reels/background_{q}.png',
    'reels_cover'					: imgsPath + 'reels/reels-cover_{q}.png',
    'bonus_cover'					: imgsPath + 'bonus/bonus_cover_{q}.png',
    'bonus_reels'					: imgsPath + 'bonus/bonus_reels_{q}.png',
    'wintable_1'					: imgsPath + 'infos/wintable_1_{q}.png',
    'wintable_2'					: imgsPath + 'infos/wintable_2_{q}.png',
    'win_dot'						: imgsPath + 'reels/win_dot_{q}.png',
    'bigwin_bg'						: imgsPath + 'bigwin/bigwinbg_{q}.png',
    'bigwin_label'					: imgsPath + 'bigwin/bigwin_label_{q}.png',
    'megawin_label'					: imgsPath + 'bigwin/megawin_label_{q}.png',
    'supermegawin_label'			: imgsPath + 'bigwin/supermegawin_label_{q}.png',
    'bonus_label'					: imgsPath + 'bigwin/bonuswin_label_{q}.png',
    'win_x2'						: imgsPath + 'reels/win_x2_{q}.png'

};

for(let i = 0; i <= 26; i++) {
    to_load['winline_' + i] = imgsPath + 'reels/lines/winline_' + i + '_{q}.png';
}

export const to_load_audio = {
    "FS_BG": audioPath + "bg_FreeSpins.ogg",
    "FS_START": audioPath + "bonus_FreeSpins_Start.ogg",
    "bonus_count": audioPath + "bonus_FreeSpins_Counter.ogg",

    "YOU_WON": audioPath + "bwin_BigWin.ogg",

    "REEL_BG_1": audioPath + "reel_Spin_1.ogg",
    "REEL_BG_2": audioPath + "reel_Spin_2.ogg",
    "REEL_BG_3": audioPath + "reel_Spin_3.ogg",

    "REEL_STOP": audioPath + "reel_Stop.ogg",

    "joker_1": audioPath + "symbol_Joker_1.ogg",
    "joker_2": audioPath + "symbol_Joker_2.ogg",
    "joker_3": audioPath + "symbol_Joker_3.ogg",

    "WIN_LINE_symbol_Bar": audioPath + "win_Bar.ogg",
    "WIN_LINE_symbol_Bell": audioPath + "win_Bell.ogg",
    "WIN_LINE_symbol_Dollar": audioPath + "win_Dollar.ogg",
    "WIN_LINE_symbol_Cherry": audioPath + "win_Cherry.ogg",
    "WIN_LINE_symbol_Joker": audioPath + "win_Joker.ogg",
    "WIN_LINE_symbol_Melon": audioPath + "win_Melon.ogg",
    "WIN_LINE_symbol_Orange": audioPath + "win_Orange.ogg",
    "WIN_LINE_symbol_Plum": audioPath + "win_Plum.ogg",
    "WIN_LINE_symbol_Star": audioPath + "win_Star.ogg",

    "joker_blend": audioPath + "win_Joker_Change.ogg",
    "WIN_X2": audioPath + "win_Multiplier.ogg",
	Jackpot_sound: assetsPath + "JokerWinBanner/Jackpot_sound.mp3",
	JokerBonus_alert: assetsPath + "JokerWinBanner/JokerBonus_alert.mp3",
};

export const to_load_json = {
    'infotext' 				: assetsPath + "info/info_{l}.json"
};

export const to_load_fonts = {
    'win_font' :	{
        "img":	imgsPath + 'fonts/win_font.png',
        "xml":	imgsPath + 'fonts/win_font.xml'
    },

    'bigwin_fonts' : {
        'img':	imgsPath + 'fonts/font_bigwin-export.png',
        'xml':	imgsPath + 'fonts/font_bigwin-export.xml'
    },

    'font_wintable' : {
        'img':	imgsPath + 'fonts/font_wintable.png',
        'xml':	imgsPath + 'fonts/font_wintable.xml'
    }
};

import {madnes_audio_allow_multiple, madnes_set_audio_volume} from "../../framework/src/engine/madnes/madnes_audio";

export function set_sounds(server_config)
{
    var vol = 1;

    if(typeof server_config["volume"]["bigWin"] !== "undefined")
    {
        vol = server_config["volume"]["bigWin"];
        madnes_set_audio_volume('YOU_WON', vol);
    }

    if(typeof server_config["volume"]["buttonEffect"] !== "undefined")
    {
        vol = server_config["volume"]["buttonEffect"];

        madnes_set_audio_volume('button_click', vol);
    }

    if(typeof server_config["volume"]["spin"] !== "undefined")
    {
        vol = server_config["volume"]["spin"];

        madnes_set_audio_volume('REEL_BG_1', vol);
        madnes_set_audio_volume('REEL_BG_2', vol);
        madnes_set_audio_volume('REEL_BG_3', vol);
    }

    if(typeof server_config["volume"]["stopReel"] !== "undefined")
    {
        vol = server_config["volume"]["stopReel"];
        madnes_set_audio_volume('REEL_STOP', vol);
    }

    if(typeof server_config["volume"]["winAnim"] !== "undefined")
    {
        vol = server_config["volume"]["winAnim"];

        madnes_set_audio_volume('WIN_LINE_symbol_Bar', vol);
        madnes_set_audio_volume('WIN_LINE_symbol_Bell', vol);
        madnes_set_audio_volume('WIN_LINE_symbol_Dollar', vol);
        madnes_set_audio_volume('WIN_LINE_symbol_Cherry', vol);
        madnes_set_audio_volume('WIN_LINE_symbol_Joker', vol);
        madnes_set_audio_volume('WIN_LINE_symbol_Melon', vol);
        madnes_set_audio_volume('WIN_LINE_symbol_Orange', vol);
        madnes_set_audio_volume('WIN_LINE_symbol_Plum', vol);
        madnes_set_audio_volume('WIN_LINE_symbol_Star', vol);

        madnes_set_audio_volume('joker_blend', vol);
    }


    if(typeof server_config["volume"]["winCounter"] !== "undefined")
    {
        vol = server_config["volume"]["winCounter"];

        madnes_set_audio_volume('remittance_A', vol);
        madnes_set_audio_volume('remittance_B', vol);

        madnes_set_audio_volume('bonus_count', vol);
    }


    if(typeof server_config["background"]["freeSpinsBackground"] != "undefined") {
        vol = server_config["background"]["freeSpinsBackground"];

        madnes_set_audio_volume('FS_BG', vol);
        madnes_set_audio_volume('FS_START', vol);
    }

    if(typeof server_config["miscSounds"]["miscSounds1"] !== "undefined") {

        vol = server_config["miscSounds"]["miscSounds1"];

        madnes_set_audio_volume('coins_loop', vol);
    }

    if(typeof server_config["miscSounds"]["miscSounds2"] !== "undefined") {

        vol = server_config["miscSounds"]["miscSounds2"];

        madnes_set_audio_volume('WIN_X2', vol);
    }

    if(typeof server_config["miscSounds"]["miscSounds3"] !== "undefined") {

        vol = server_config["miscSounds"]["miscSounds3"];

        madnes_set_audio_volume('joker_1', vol);
        madnes_set_audio_volume('joker_2', vol);
        madnes_set_audio_volume('joker_3', vol);
    }

    madnes_audio_allow_multiple("REEL_STOP");
}

